export const galleryIndexById = (list, id) => {
  const index = list.findIndex(
    gallery => gallery.get('id') === id,
  );
  return {
    index: Math.max(index, 0),
    found: index > -1,
  };
};
